module.exports = "/_next/static/images/a6fc47cd2bcc17dfefb5c87c8939cd2a-mockup-transfer-fgts@0.75x.jpg.webp";